import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { NativeWindoRefService } from '../shared/services/native-windo-ref.service';
import { Router } from '@angular/router';

@Component({
  selector: 'tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['tutorial.component.css']
})

export class tutorialComponent {


  constructor(public dialogRef: MatDialogRef<tutorialComponent>,private restApiService:RestApiService,private router: Router) {
  }

 close(){
  this.dialogRef.close();
 }

 start(){
  this.dialogRef.close();
  this.router.navigateByUrl('/questionnaires');
 }

 openLink(link){
   window.open(link)
 }
}



// WEBPACK FOOTER //
// ./src/app/tutorial/tutorialComponent.ts